// Mock data for Fodindin Cagnotte

export const liveDonations = [
  { donor: 'Fodindin · Bourse Verte', amount: '5 000 FCFA', cause: "Forage d'eau potable village de N'Zikro", country: "Côte d'Ivoire", type: 'Yako' },
  { donor: 'TEST_E2E', amount: '25 000 FCFA', cause: "Forage d'eau potable village de N'Zikro", country: "Côte d'Ivoire", type: 'Yako' },
  { donor: 'Fodindin · Hivernage 2026', amount: '1 600 FCFA', cause: 'TEST_Yako_1781950080', country: "Côte d'Ivoire", type: 'Yako' },
  { donor: 'Diaspora Ivoirienne de Paris', amount: '2 000 FCFA', cause: 'TEST_Yako_1781950080', country: "Côte d'Ivoire", type: 'Yako' },
  { donor: 'TEST_DoubleMatch', amount: '4 000 FCFA', cause: 'TEST_Yako_1781950080', country: "Côte d'Ivoire", type: 'Yako' },
  { donor: 'Fodindin · Hivernage 2026', amount: '75 000 FCFA', cause: 'TEST_Yako_1781950080', country: "Côte d'Ivoire", type: 'Yako' },
  { donor: 'TEST_BigDonor', amount: '1 000 000 FCFA', cause: 'TEST_Yako_1781950080', country: "Côte d'Ivoire", type: 'Yako' },
  { donor: 'TEST_NoBonus', amount: '5 000 FCFA', cause: 'TEST_Yako_1781950080', country: "Côte d'Ivoire", type: 'Yako' },
  { donor: 'OG', amount: '1 500 FCFA', cause: 'TEST_Joy_1781950080', country: "Côte d'Ivoire", type: 'Joie' },
  { donor: 'ShareCard', amount: '2 500 FCFA', cause: 'TEST_Joy_1781950080', country: "Côte d'Ivoire", type: 'Joie' },
  { donor: 'Anonyme', amount: '10 000 FCFA', cause: 'TEST_Joy_1781950080', country: "Côte d'Ivoire", type: 'Joie' },
];

export const stats = {
  active: '6+',
  donors: '41+',
  collected: '2 309 754',
};

export const joyeuseCategories = [
  { label: 'Mariage', icon: 'Heart' },
  { label: 'Naissance', icon: 'Baby' },
  { label: 'Anniversaire', icon: 'Cake' },
  { label: 'Réussite', icon: 'GraduationCap' },
  { label: 'Voyage', icon: 'Plane' },
  { label: 'Cadeau groupé', icon: 'Gift' },
  { label: 'Projet', icon: 'Lightbulb' },
  { label: 'Autre fête', icon: 'Sparkles' },
];

export const yakoCategories = [
  { label: 'Obsèques', icon: 'Cloud' },
  { label: 'Maladie & soins', icon: 'Stethoscope' },
  { label: 'Difficulté', icon: 'LifeBuoy' },
  { label: 'Sinistre', icon: 'AlertTriangle' },
  { label: 'Soutien famille', icon: 'Users' },
  { label: 'Autre solidarité', icon: 'HandHeart' },
];

export const campaigns = [
  {
    id: 'f23a5714-68ca-43db-a402-19744a0ce88e',
    type: 'Yako',
    country: "Côte d'Ivoire",
    title: 'TEST_Yako_1781950080',
    description: 'Une histoire de solidarité testée par pytest. Merci.',
    raised: 1109100,
    goal: 200000,
    donors: 11,
    image: 'https://images.unsplash.com/photo-1655720359248-eeace8c709c5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200',
  },
  {
    id: 'a6604028-86e8-482a-95e9-fb03f17fab50',
    type: 'Joyeuse',
    country: "Côte d'Ivoire",
    title: 'TEST_Joy_1781950080',
    description: 'Une histoire de solidarité testée par pytest. Merci.',
    raised: 28777,
    goal: 100000,
    donors: 7,
    image: 'https://images.unsplash.com/photo-1647616927583-1d44a79a38a5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200',
  },
  {
    id: 'f8820509-dd86-444e-9895-0654a3ff6440',
    type: 'Joyeuse',
    country: "Côte d'Ivoire",
    title: 'TEST_Mariage Campaign',
    description: 'A wonderful celebration we want to organize for our friends and family.',
    raised: 10000,
    goal: 200000,
    donors: 1,
    image: 'https://images.unsplash.com/photo-1647616927583-1d44a79a38a5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200',
  },
  {
    id: 'b86d76de-22b9-4950-aeea-01701ffef318',
    type: 'Yako',
    country: "Côte d'Ivoire",
    title: 'TEST_Yako_1781949972',
    description: 'Une histoire de solidarité testée par pytest. Merci.',
    raised: 1113100,
    goal: 200000,
    donors: 13,
    image: 'https://images.unsplash.com/photo-1655720359248-eeace8c709c5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200',
  },
  {
    id: '3a7c5004-742f-48b1-856b-7bbfd79c6cbb',
    type: 'Joyeuse',
    country: "Côte d'Ivoire",
    title: 'TEST_Joy_1781949972',
    description: 'Une histoire de solidarité testée par pytest. Merci.',
    raised: 48777,
    goal: 100000,
    donors: 9,
    image: 'https://images.unsplash.com/photo-1647616927583-1d44a79a38a5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200',
  },
  {
    id: 'd7cff3dc-02ed-41ea-9d11-1f3d30408702',
    type: 'Joyeuse',
    country: "Côte d'Ivoire",
    title: 'TEST_Mariage Campaign',
    description: 'A wonderful celebration we want to organize for our friends and family.',
    raised: 0,
    goal: 200000,
    donors: 0,
    image: 'https://images.unsplash.com/photo-1647616927583-1d44a79a38a5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200',
  },
];

export const wallMessages = [
  { id: 'w-og-1', type: 'Joie', donor: 'OG', amount: '1 500 FCFA', message: 'test' },
  { id: 'w-hiv-1', type: 'Yako', donor: 'Fodindin · Hivernage 2026', amount: '1 600 FCFA', message: 'Bonification 🌧️ Hivernage 2026 (+40%)' },
  { id: 'w-share-1', type: 'Joie', donor: 'ShareCard', amount: '2 500 FCFA', message: 'Merci !' },
  { id: 'w-dip-1', type: 'Yako', donor: 'Diaspora Ivoirienne de Paris', amount: '2 000 FCFA', message: 'Don de contrepartie via Diaspora Ivoirienne de Paris' },
  { id: 'w-dip-2', type: 'Yako', donor: 'Diaspora Ivoirienne de Paris', amount: '2 000 FCFA', message: 'Don de contrepartie via Diaspora Ivoirienne de Paris' },
  { id: 'w-hiv-2', type: 'Yako', donor: 'Fodindin · Hivernage 2026', amount: '75 000 FCFA', message: 'Bonification 🌧️ Hivernage 2026 (+40%)' },
];

export const countries = [
  { code: 'CI', name: "Côte d'Ivoire", flag: '🇨🇮' },
  { code: 'SN', name: 'Sénégal', flag: '🇸🇳' },
  { code: 'ML', name: 'Mali', flag: '🇲🇱' },
  { code: 'BF', name: 'Burkina Faso', flag: '🇧🇫' },
  { code: 'TG', name: 'Togo', flag: '🇹🇬' },
  { code: 'BJ', name: 'Bénin', flag: '🇧🇯' },
  { code: 'CM', name: 'Cameroun', flag: '🇨🇲' },
  { code: 'GN', name: 'Guinée', flag: '🇬🇳' },
  { code: 'NE', name: 'Niger', flag: '🇳🇪' },
  { code: 'FR', name: 'France', flag: '🇫🇷' },
  { code: 'BE', name: 'Belgique', flag: '🇧🇪' },
  { code: 'CA', name: 'Canada', flag: '🇨🇦' },
];

export const navLinks = [
  { label: 'Découvrir', href: '#decouvrir' },
  { label: 'Cagnotte Joyeuse', href: '#joyeuse' },
  { label: 'Cagnotte Yako', href: '#yako' },
  { label: 'Le Mur', href: '#mur', badge: 'NOUVEAU' },
  { label: 'Ambassadeurs', href: '#ambassadeurs' },
  { label: 'Cercles', href: '#cercles', badge: 'B2B' },
  { label: 'Bourses', href: '#bourses', badge: 'NOUVEAU' },
  { label: 'Foundations', href: '#foundations', badge: 'PRO' },
  { label: 'Crisis', href: '#crisis', badge: 'LIVE' },
  { label: 'Saisons', href: '#saisons', badge: 'NOUVEAU' },
];
